(() => {
  console.log("✅ Delivery script loaded");

  const WEEKEND = [0, 6];
  let UK_BANK_HOLIDAYS = [];

  /* ---------------------------
     UK Bank Holidays (API + cache)
  --------------------------- */
  const loadUKHolidays = async () => {
    try {
      const cache = localStorage.getItem("uk_holidays");

      if (cache) {
        UK_BANK_HOLIDAYS = JSON.parse(cache).map(d => new Date(d + "T00:00:00"));
        return;
      }

      const res = await fetch("https://www.gov.uk/bank-holidays.json");
      const data = await res.json();

      const holidays = data["england-and-wales"].events.map(e => e.date);

      localStorage.setItem("uk_holidays", JSON.stringify(holidays));

      UK_BANK_HOLIDAYS = holidays.map(d => new Date(d + "T00:00:00"));
    } catch (err) {
      console.warn("⚠️ UK holidays failed, fallback to weekends only", err);
      UK_BANK_HOLIDAYS = [];
    }
  };

  /* ---------------------------
     Date Helpers
  --------------------------- */
  const isWeekend = d => WEEKEND.includes(d.getDay());

  const isBankHoliday = d =>
    UK_BANK_HOLIDAYS.some(h =>
      h.getFullYear() === d.getFullYear() &&
      h.getMonth() === d.getMonth() &&
      h.getDate() === d.getDate()
    );

  const isWorkingDay = d => !isWeekend(d) && !isBankHoliday(d);

  const addWorkingDays = (date, days) => {
    const result = new Date(date);
    let added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (isWorkingDay(result)) added++;
    }

    return result;
  };

  const formatDate = d =>
    d.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "numeric",
      month: "short"
    });

  /* ---------------------------
     Variant handling (swatches safe)
  --------------------------- */
  const getVariantId = () => {
    const params = new URLSearchParams(window.location.search);
    const urlId = params.get("variant");
    if (urlId) return parseInt(urlId, 10);

    const input = document.querySelector('input[name="id"]');
    if (input?.value) return parseInt(input.value, 10);

    return null;
  };

  /* ---------------------------
     Render
  --------------------------- */
  const render = () => {
    const el = document.querySelector("#delivery-message");
    if (!el) return;

    const now = new Date();

    const min = 3;
    const max = 5;

    const start = addWorkingDays(now, min);
    const end = addWorkingDays(now, max);

    el.innerHTML = `
      <span>Delivery ${formatDate(start)} – ${formatDate(end)}</span>
    `;
  };

  /* ---------------------------
     Init (safe for swatches + variants)
  --------------------------- */
  const init = async () => {
    await loadUKHolidays();

    render();

    // Swatches / theme updates
    document.addEventListener("click", () => setTimeout(render, 80));
    document.addEventListener("change", () => setTimeout(render, 80));
    document.addEventListener("variant:change", () => setTimeout(render, 80));

    // Catch URL variant changes (some swatch systems use this)
    let lastUrl = location.href;

    const observer = new MutationObserver(() => {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        render();
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();